<template>
  <div>
    <b-container style="margin-bottom: 100px; text-align: center">
      <b-container>
        <b-row align-h="around" class="margin-top">
          <b-col xs="2" sm="2" md="2" lg="3" xl="4"></b-col>
          <b-col xs="8" sm="8" md="8" lg="6" xl="4" :class="[overrideColor]">
            <!-- Invalid Credentials Alert -->
            <b-alert
              :class="[getLanguageDirection, 'login invalid']"
              v-show="show_invalid_credential_message"
              show
              variant="danger"
            >
              <span>{{ $t('msg.invalid_credentials') }}</span>
            </b-alert>

            <!-- Login Form -->
            <b-form @submit.prevent="handleSubmit" class="border text-center">
              <img
                :src="getProductBrandImageUrl()"
                v-if="getBrandLogo()"
                class="d-inline-block align-top brandlogo"
                alt="logo"
              />

              <!-- Username -->
              <b-form-group
                :class="[getLanguageDirection, 'login']"
                id="user-name-input-group-1"
                style="margin-top:20px"
              >
                <b-form-input
                  v-model="username"
                  name="username"
                  v-validate="'required'"
                  id="username"
                  type="text"
                  @focus="changeState()"
                  :class="{ 'input': true, 'border-danger': errors.has('username') }"
                  :placeholder="$t('msg.username')"
                ></b-form-input>
                <i v-show="errors.has('username')" class="fa fa-warning"></i>
                <span v-show="errors.has('username')" class="error">{{ $t('msg.blank_username_field') }}</span>
              </b-form-group>

              <!-- Password -->
              <b-form-group
                :class="[getLanguageDirection, 'login']"
                id="password-input-group-2"
                class="pt-3"
              >
                <b-input
                  type="password"
                  v-model="password"
                  name="password"
                  id="password"
                  v-validate="'required'"
                  @focus="changeState()"
                  :class="{ 'input': true, 'border-danger': errors.has('password') }"
                  :placeholder="$t('msg.password')"
                ></b-input>
                <i v-show="errors.has('password')" class="fa fa-warning"></i>
                <span v-show="errors.has('password')" class="error">{{ $t('msg.blank_password_field') }}</span>
              </b-form-group>

              <!-- Submit Button -->
              <b-form-group :class="[getLanguageDirection, 'login-button']" id="submit-group">
                <b-button :disabled="loggingIn" type="submit" variant="primary" class="button-size">
                  <b-spinner small v-show="loggingIn"></b-spinner>
                  {{ $t('msg.enter') }}
                </b-button>
              </b-form-group>

              <!-- ✅ NEW: Dynamic User Guide Selector OR Old Static Link -->
              <b-container v-if="showDynamicUserGuide" class="mt-3">
                <b-button
                  variant="link"
                  @click="openGuideModal"
                  class="p-0"
                  style="font-size: 14px;"
                >
                  {{ $t('msg.select_user_guide') }}
                </b-button>
              </b-container>

              <!-- ✅ OLD: Fallback Static User Guide Link -->
              <b-container v-else-if="userGuide" class="mt-3">
                <b-row align-h="center">
                  <b-col xs="12" class="text-center">
                    <b-link :href="getPdfFile" target="_blank">
                      {{ $t('msg.user_guide') }}
                    </b-link>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </b-col>
          <b-col xs="2" sm="2" md="2" lg="3" xl="4"></b-col>
        </b-row>
        <div v-if="displayRpInstructions" class="w-100 mt-3 mt-md-5 d-flex justify-content-center" >
          <div class="text-left p-3" style="border-radius: 10px; border: 1px solid lightgray;">
            <p class="font-weight-bold text-center"> {{ $t('msg.login_instruction') }} </p>
            <hr/>
            <p>{{ $t('msg.login_instruction_title') }}</p>
            <p>☐ {{ $t('msg.login_instruction_1') }}</p>
            <p>☐ {{ $t('msg.login_instruction_2') }}</p>
            <p>☐ {{ $t('msg.login_instruction_3') }}</p>
          </div>
        </div>
      </b-container>
    </b-container>

    <!-- ✅ Modal for Dynamic User Guide Selection -->
    <b-modal
      v-model="showModal"
      :title="$t('msg.user_guide_selection')"
      ok-only
      :ok-title="$t('msg.close')"
      size="md"
      centered
    >
      <b-list-group>
        <b-list-group-item
          v-for="guide in sortedGuides"
          :key="guide.position"
          @click="openUrl(guide.url)"
          style="cursor: pointer;"
          class="d-flex justify-content-between align-items-center"
        >
          <span>{{ guide.text }}</span>
          <b-icon-arrow-up-right></b-icon-arrow-up-right>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import { userService } from '../_services'
import { apiUrl, rootUrl } from '../_config'

export default {
  data() {
    return {
      username: '',
      password: '',
      loggingIn: false,
      show_invalid_credential_message: false,
      overrideColor: '',
      userGuide: '',           // old static guide from cookie
      dynamicGuides: [],       // new list from API: userGuides[]
      showModal: false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  computed: {
    getLanguageDirection() {
      return this.$store.state.home.isRTL ? 'rtl' : 'ltr'
    },
    sortedGuides() {
      return this.dynamicGuides
        .slice()
        .sort((a, b) => parseInt(a.position, 10) - parseInt(b.position, 10))
    },
    showDynamicUserGuide() {
      return this.sortedGuides.length > 0
    },
    getPdfFile() {
      if (!this.userGuide) return '#'
      const lang = this.$store.state.home.language === 'ms' ? 'ms' : 'en'
      return `https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/${this.userGuide}_${lang}.pdf`
    },
    displayRpInstructions() {
      const showRpInstructions = this.$cookies.get('show_rp_instructions')
      if(showRpInstructions && showRpInstructions.trim() !== ''){
        return showRpInstructions === 'Y';
      }else
        return false
    }
  },
  methods: {
    changeState() {
      this.show_invalid_credential_message = false
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loggingIn = true
          const meta = window.location.pathname.split('/').pop() || null

          userService.login(this.username, this.password, meta)
            .then(() => {
              window.location.href = rootUrl() + 'home'
            })
            .catch(error => {
              console.error('Login failed:', error)
              this.loggingIn = false
              this.show_invalid_credential_message = true
            })
        }
      })
    },
    getProductBrandImageUrl() {
      const logo = this.getBrandLogo()
      return logo ? apiUrl() + 'media/logo/' + logo : ''
    },
    getBrandLogo() {
      const logo = this.$cookies.get('product_logo')
      return logo && logo.trim() !== '' ? logo : undefined
    },
    openGuideModal() {
      this.showModal = true
    },
    openUrl(urlSuffix) {
      if (!urlSuffix) return
      const lang = this.$store.state.home.language === 'ms' ? 'ms' : 'en'
      const fullUrl = `https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/${urlSuffix}_${lang}.pdf`
      window.open(fullUrl, '_blank')
      this.showModal = false
    },
    fetchUserGuides() {
      const productKey = this.$cookies.get('nedas_product')
      const lang = this.$store.state.home.language === 'ms' ? 'ms' : 'en'

      if (!productKey || productKey.trim() === '') {
        console.warn('Missing or empty product key in cookie: nedas_product')
        this.dynamicGuides = []
        return
      }

      userService.getUserGuide(lang, productKey.trim())
        .then(response => {
          const data = response.data
          if (data && Array.isArray(data.userGuides)) {
            this.dynamicGuides = data.userGuides
          } else {
            console.warn('Invalid or missing userGuides in response:', data)
            this.dynamicGuides = []
          }
        })
        .catch(err => {
          console.error('Failed to load dynamic user guide:', err)
          this.dynamicGuides = []
        })
    },
  },
  created() {

    const productName = this.$cookies.get('product_name')
    if (productName && productName.trim() !== '') {
      document.title = productName
    }

    const overrideColor = this.$cookies.get('override_color')
    if (overrideColor && overrideColor.trim() !== '') {
      this.overrideColor = overrideColor
    }

    const cookieGuide = this.$cookies.get('user_guide')
    if (cookieGuide && cookieGuide.trim() !== '') {
      this.userGuide = cookieGuide.trim()
    }

    const productKey = this.$cookies.get('nedas_product')
    const lang = this.$store.state.home.language === 'ms' ? 'ms' : 'en'

    if (!productKey || productKey.trim() === '') {
      console.warn('Missing or empty product key in cookie: nedas_product')
      this.dynamicGuides = []
      return
    }

    this.fetchUserGuides()
  },
  watch: {
    '$store.state.home.language': {
      handler(newLang) {
        this.fetchUserGuides()
        console.log('watching language change',  newLang)
      },
      immediate: false
    }
  },
}
</script>

<style>

  .rtl.login-button {
    direction: rtl;
  }

  .rtl.login {
    direction: rtl;
    text-align: right;
  }

  .rtl.login .error {
    direction: rtl;
    text-align: right;
    float: right;
  }

  .border {
    border: 1px solid black;
    background: rgba(255, 255, 255, .75);
    box-shadow: 1px 2px 10px -1px;
    margin-top: 10px;
    padding: 30px;
    /*height: 300px;*/
  }

  .button-size {
    margin-top: 50px;
    width: 80%;
  }

  .help .is-danger {
    color: red;
  }

  .borderColor {
    border-color: red;
  }

  .error {
    color: #f22435;
    font-size: 12px;
    float: left;
  }

  .invalid {
    font-size: 14px;
  }

  .brandlogo {
    max-height: 150px;
    max-width: 275px;
  }

  .bnm .border {
    border: 1px solid black;
    background: rgba(109, 123, 144,.54);
    box-shadow: 1px 2px 10px -1px;
    margin-top: 10px;
    padding: 30px;
  }

  .bnm .btn-primary {
    color: #fff;
    background-color: #0A317A;
    border-color: #0A317A;
  }

  .bnm .btn-primary:hover {
    color: #fff;
    background-color: #0A317A;
    border-color: #0A317A;
  }

  @media screen and (min-width: 320px) and (max-width: 992px) {
    .brandlogo {
      max-height: 85px;
      max-width: 220px;
    }
  }
</style>

<style scoped>

  .margin-top {
    margin-top: 100px;
  }

  @media screen and (min-height: 601px) and (max-height: 720px) {
    .margin-top {
      margin-top: 30px;
    }
  }

  @media screen and (max-height: 600px) {
    .margin-top {
      margin-top: 10px;
    }
  }

</style>
